/**
 * @description 可配置左中右的头部组件
 * @author wayou
 */

import React, { Component } from 'react';
import './configurableHeader.scss';
import { classMapSet } from '@umu/umu-util';

export interface IConfigurableHeaderConfig {
    label?: string;
    clsName?: string;
    child?: JSX.Element;
    callback?(): void;
}

interface IProps {
    clsName: string;
    theme?: 'default' | 'none'; // 默认无背景，只须布局，在旧的登录页面用。但页面内要用 default 主题保持和 userBar 相同样式
    config: {
        leftProp?: IConfigurableHeaderConfig;
        centerProp?: IConfigurableHeaderConfig;
        rightProp?: IConfigurableHeaderConfig;
    };
}

class ConfigurableHeader extends Component<IProps, {}> {
    public static defaultProps = {
        theme: 'none',
    };

    constructor(props: IProps) {
        super(props);
        this.getClassName = this.getClassName.bind(this);
    }

    public getClassName(data?: IConfigurableHeaderConfig) {
        if (!data) {
            return '';
        }
        const classObj: { [key: string]: boolean } = {
            'umu-btn': true,
        };
        if (data && data.clsName) {
            classObj[data.clsName] = true;
        }
        return classMapSet(classObj);
    }

    public render() {
        const config = this.props.config;
        return (
            <div className={'configurable-header ' + this.props.clsName + ` theme-${this.props.theme}`}>
                {!config.leftProp ? null : (
                    <div className="left-section">
                        {config.leftProp.child ? (
                            config.leftProp.child
                        ) : (
                            <a
                                className={this.getClassName(config.leftProp)}
                                onClick={config.leftProp && config.leftProp.callback}
                                dangerouslySetInnerHTML={{ __html: (config.leftProp && config.leftProp.label) || '' }}
                            ></a>
                        )}
                    </div>
                )}
                {!config.rightProp ? null : (
                    <div className="right-section">
                        {config.rightProp.child ? (
                            config.rightProp.child
                        ) : (
                            <a
                                className={this.getClassName(config.rightProp)}
                                onClick={config.rightProp && config.rightProp.callback}
                                dangerouslySetInnerHTML={{ __html: (config.rightProp && config.rightProp.label) || '' }}
                            ></a>
                        )}
                    </div>
                )}
                {!config.centerProp ? null : (
                    <div className="center-section">
                        {config.centerProp.child ? (
                            config.centerProp.child
                        ) : (
                            <a
                                className={this.getClassName(config.centerProp)}
                                onClick={config.centerProp && config.centerProp.callback}
                                dangerouslySetInnerHTML={{
                                    __html: (config.centerProp && config.centerProp.label) || '',
                                }}
                            ></a>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default ConfigurableHeader;
